export const BRAND_ID = '10AA0B00-8C91-4D25-BC4F-CEFEE2E2C305';

